<template>
    <GuestPage>
        <div class="account-login-wrapper">
            <img :src="LoginBg" alt="login-background" class="backgroun-img" />
            <div class="login-form">
                <div>
                    <img :src="CompanyLogo" alt="fleebe-logo" class="company-logo" />

                    <h1>
                        {{ $t("pages.accounts.login.title") }}
                    </h1>
                    <div class="form">
                        <AppInputText v-model="email" :label="$t('pages.accounts.login.email')" />
                        <AppInputText v-model="password" type="password" :label="$t('pages.accounts.login.password')" />
                        <AppButton :text="$t('pages.accounts.login.button')" size="full-width" variant="primary"
                            @click="handleLogin" />
                        <AppButton class="ms-login-btn" :text="$t('pages.accounts.login.ms_button')" size="full-width"
                            variant="secondary" />
                    </div>
                </div>
            </div>
        </div>
    </GuestPage>
</template>

<script setup lang="ts">
import GuestPage from "@/layout/guest/GuestPage.vue";
import LoginBg from "@/assets/images/login/background.png";
import CompanyLogo from "@/assets/images/login/fleebe-logo.png";
import AppInputText from "@/components/AppInputText.vue";
import AppButton from "@/components/AppButton.vue";

import useAuthenticationService from "@/services/useAuthenticationService";
import { ref } from "vue";
import router from "@/router/router";

const authService = useAuthenticationService();

const email = ref("");
const password = ref("");

const handleLogin = async () => {
    try {
        await authService.login({ email: email.value, password: password.value, rememberMe: false });
        // Redirect user or reload page
        router.push("/app");
    } catch (error) {
        alert("Login failed: " + error);
    }
};
</script>

<style scoped lang="scss">
.account-login-wrapper {
    display: flex;
    min-height: 100vh;

    .login-form {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;

        .company-logo {
            height: 5rem;
            width: auto;
            margin-bottom: 2.5rem;
        }

        .form {
            margin-top: 3rem;

            .ms-login-btn {
                margin-top: 1.5rem;
            }
        }
    }

    .backgroun-img {
        flex: 1;
        position: relative;
        overflow: hidden;
        object-fit: cover;
    }
}
</style>
